import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Route, Switch} from 'react-router';

import * as selector from '../selectors';

import Question from './card/Question';
import CreateCard from './card/CreateCard';
import FindCard from './card/FindCard';
import NotFound from './NotFound';

@connect(state => ({
	location: selector.getLocation(state),
	settings: selector.getSettings(state),
}))
export default class extends Component {
	static propTypes = {
		location: PropTypes.object,
		settings: PropTypes.object,
	}

	render() {
		const {settings, location} = this.props;

		if (!Number(settings.pass_on)) {
			return (
				<div>
					Функционал электронных карт выключен
				</div>
			);
		}

		const backRoute = location.pathname === '/card' ? '/' : '/card';

		return (
			<Fragment>
				<div className="container cards">
					<Switch>
						{!Number(settings.create_card) ? (
							<Route path='/card' component={FindCard} />
						) : (
							<Fragment>
								<Route exact path='/card' component={Question} />
								<Route exact path='/card/create' component={CreateCard} />
								<Route exact path='/card/find' component={FindCard} />
							</Fragment>
						)}
						<Route component={NotFound} />
					</Switch>
				</div>
				<Link to={backRoute} className="back" title="Назад" />
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Card.js